module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ExChangeDetailView.js"));
	}, "ExChangeDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ExChangeDetailView!./src/pages/PunchClock/Bean/ExChangeDetail/ExChangeDetailView.js
// module id = 1263
// module chunks = 438